import React, { useState, useEffect } from 'react';

import config from '../../config/config';
import { IoCarOutline } from "react-icons/io5";
import { IoExpandOutline } from "react-icons/io5";
import FindValueByAttributeCode from '../property/findValueByAttributeCode';
import FormatPrice from '../property/formatPrice';


import Card from 'react-bootstrap/Card';



import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';


const ProjectCard = ({item, beforeSlugUrl}) => { 

    const checkAttributeExits = (attributeCode, attributes) => {
        return attributes.find(item => item.code === attributeCode) !== undefined;
    }

    const getPropertyPrice = (attributeCode, attributes) => {
        const attribute =  attributes.find(item => item.code === attributeCode);
        return attribute.value;
    }
    
    return <Card className='property-card mb-4 border-0 shadow position-relative'>
                <Card.Img variant="top" src={`${config.uploadUrl}/uploads/projects/pictures/${item.image}?auto=compress&cs=tinysrgb&w=300&h=250&dpr=2`} />
                <Card.Body>
                    <Card.Title className='mb-3'>{item.title}, {item.location}, {item.city}</Card.Title>
                    <Card.Subtitle className="mb-2 money"> 
                        { checkAttributeExits('price', item.attributes) ? <FormatPrice price={getPropertyPrice('price', item.attributes)} /> : ''}
                    </Card.Subtitle>
                    <Card.Text className='info mb-0'>
                        { checkAttributeExits('reserved_parking', item.attributes) ? <span><IoCarOutline /> <FindValueByAttributeCode attributeCode={'reserved_parking'} attributes={item.attributes} /></span> : ''}
                        { checkAttributeExits('washrooms', item.attributes) ? <span><IoCarOutline /> <FindValueByAttributeCode attributeCode={'washrooms'} attributes={item.attributes} /></span> : ''}
                        { checkAttributeExits('washroom', item.attributes) ? <span><IoCarOutline /> <FindValueByAttributeCode attributeCode={'washroom'} attributes={item.attributes} /></span> : ''}
                        <span>
                            <IoExpandOutline />&nbsp;
                            { checkAttributeExits('area', item.attributes) ? <FindValueByAttributeCode attributeCode={'area'} attributes={item.attributes} /> : ''}
                            { checkAttributeExits('flat_area', item.attributes) ? <FindValueByAttributeCode attributeCode={'flat_area'} attributes={item.attributes} /> : ''}
                            &nbsp;{ checkAttributeExits('area_unit', item.attributes)? <FindValueByAttributeCode attributeCode={'area_unit'} attributes={item.attributes} /> : ''}
                        </span>
                    </Card.Text>
                    <Card.Link href={`/project/${item.slug_url}`} className='flow-btn position-absolute w-100 h-100 top-0 start-0 ms-0'></Card.Link>
                </Card.Body>
            </Card>
}
function mapStateToProps(state) {
    return {
        
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        
    };
}

  
export default connect(mapStateToProps, mapDispatchToProps)(ProjectCard);